import { ITeamLeadPermissionsJson } from '@scale/shared/types/expertManagement';
import { IUserJson } from '@scale/shared/types/user';
import { CAN_PERFORM_ACTIONS_ROLES } from 'react-scale/components/ExpertManagement/constants';
import { create } from 'zustand';

export type ClientState = {
  loggedInUser: IUserJson | undefined;
  setLoggedInUser: (user: IUserJson) => void;
  permissions: ITeamLeadPermissionsJson;
  setPermissions: (permissions: ITeamLeadPermissionsJson) => void;
};

export const useClientStore = create<ClientState>(set => ({
  loggedInUser: undefined,
  setLoggedInUser: user => set(() => ({ loggedInUser: user })),
  permissions: { worker: '', roles: [], permissionedPodTypes: [] },
  setPermissions: permissions => set(() => ({ permissions })),
}));

export const loggedInUserSelector = (state: ClientState): ClientState['loggedInUser'] =>
  state.loggedInUser;
export const setLoggedInUserSelector = (state: ClientState): ClientState['setLoggedInUser'] =>
  state.setLoggedInUser;
export const permissionsSelector = (state: ClientState): ClientState['permissions'] =>
  state.permissions;
export const setPermissionsSelector = (state: ClientState): ClientState['setPermissions'] =>
  state.setPermissions;
export const hasModifyPermissionsSelector = (state: ClientState): boolean =>
  (state.permissions.roles ?? []).some(r => CAN_PERFORM_ACTIONS_ROLES.includes(r));
